import * as R from 'ramda';
/* global angular */

export default function PerformRiskAssessmentDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  loaderService,
  alerts,
  confirmControlsReviewDialog,
  selectRiskControlsForReviewDialog,
  vmDataService,
  confirmDialog,
  updateFrequencyConfirmDialog,
) {
  const vm = this;

  vm.handlePerformRiskAssessmentFormSubmit = _handlePerformRiskAssessmentFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handlePerformRiskAssessmentFormSubmit($event) {
    if ($scope.performRiskAssessmentForm.$valid) {
       if ((vm.product.controlReviewFrequency == 'biennially' || vm.product.riskAssessmentFrequency == 'biennially')
          && !_isScoreValid()
      ){
        _handleCheckResetFrequency($event);
      } else {
        _handleSaveRiskAssessment($event);
      }
    }
      
  }

  function _handleSaveRiskAssessment($event) {
      loaderService.showViewLoader = true;
      const riskAssessmentQuestions = _assembleQuestions();

      vmDataService.createRiskAssessment(vm.product.productId, riskAssessmentQuestions)
        .then((createRiskAssessmentResponse) => {
          vmDataService.getVendorCustom(vm.vendor.vendorId)
            .then((getVendorResponse) => {
              angular.extend(vm.vendor, getVendorResponse.data);
              const product = R.find(R.propEq('productId', vm.product.productId))(getVendorResponse.data.products);
              if (product) {
                angular.extend(vm.product, product);
              }
            }).finally(() => {
              if (!createRiskAssessmentResponse.data) {
                alerts.error('Error occurred while saving the Risk Assessment.');
              } else {
                alerts.success('Risk Assessment has been saved successfully.');
                $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
                $rootScope.$broadcast('refreshNotifications');
              }
              loaderService.showViewLoader = false;
              _closeDialog();

              if (vm.saveType === 'saveAndReviewControls') {
                vmDataService.getProductRiskControlReviewTask(vm.product.productId, true, false)
                  .then((response) => {
                    const controlsReviewTask = response.data.result;

                    vm.currentControlsReviewTask = controlsReviewTask;
                    /** Already has a task in process */
                    if (vm.currentControlsReviewTask && vm.currentControlsReviewTask.length > 0) {
                      loaderService.showViewLoader = false;
                      return _showConfirmControlsReviewDialog($event, {
                        vendor: vm.vendor,
                        product: vm.product,
                        currentControlsReviewTask: vm.currentControlsReviewTask[0],
                      });
                    }
                    /** No task started yet */
                    vmDataService.getControlsForProductReview(vm.product.productId)
                      .then((getControlsResponse) => {
                        loaderService.showViewLoader = false;
                        const product = getControlsResponse.data.product;

                        angular.extend(vm.product, product);
                        return _showSelectRiskControlsForReviewDialog($event, {
                          riskControlReviewTaskId: -1,
                          product: vm.product,
                          vendor: vm.vendor,
                        });
                      });
                  });
              }
            });
          // TODO: If getVendorCustom fails, then reload the document.
        });
  }

  function _handleCheckResetFrequency($event) {
    ssDialogService.dialogs.vendorManagement.confirmResetFrequencyDialog = ssDialogService.alert(
      updateFrequencyConfirmDialog.getOptions($event,{
          product: vm.product,
          updateCallBack: _broadcastEvents,
        }));

    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmResetFrequencyDialog);   
  }

  function _broadcastEvents($event){
    _handleSaveRiskAssessment($event);
  }

  function _isScoreValid($event) {
    let isScoreValid = true;
    vm.riskCategories.forEach(category => {
        if((category.riskCategoryId==1 && category.selectedScoreValue > 0) ||
              (category.riskCategoryId==2 && category.selectedScoreValue > 0) ||
              (category.riskCategoryId==3 && category.selectedScoreValue > 0) ||
              (category.riskCategoryId==5 && category.selectedScoreValue > 0)){
          isScoreValid =false;  
        }
    });
    return isScoreValid;
  }

  function _showConfirmControlsReviewDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.confirmControlsReviewDialog = ssDialogService.alert(
      confirmControlsReviewDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmControlsReviewDialog);
  }

  function _showSelectRiskControlsForReviewDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog = ssDialogService.alert(
      selectRiskControlsForReviewDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog);
  }

  function _assembleQuestions() {
    const questions = R.map(
      riskCategory => ({
        riskCategoryId: riskCategory.riskCategoryId,
        riskCategoryScore: riskCategory.selectedScoreValue,
        note: riskCategory.note,
      }),
      vm.riskCategories
    );

    return questions;
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.performRiskAssessmentDialog);
  }
}

PerformRiskAssessmentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'loaderService',
  'alerts',
  'confirmControlsReviewDialog',
  'selectRiskControlsForReviewDialog',
  'vmDataService',
  'confirmDialog',
  'updateFrequencyConfirmDialog'
];
